function extractGivenId(pathname: string, word1: string, word2: string) {
    let firstIndex = pathname.indexOf(word1);
    firstIndex = firstIndex + word1.length;
    const lastIndex = pathname.indexOf(word2);
    const param = pathname.slice(firstIndex, lastIndex);
    return param;
}

export default extractGivenId;
